module.exports = __webpack_public_path__ + "img/flags/SK.af77361.png";